import { Box } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { esES } from '@mui/x-date-pickers/locales'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { useContext, useEffect } from 'react'
import { ExpedientesContext } from '../../providers/ExpedientesProvider'
import LabelComponent from '../LabelComponent'
import CustomDateTimeComponent from './CustomDateTimeComponent'

function DateComponent({ columna, error }) {
  const { campos_expediente, setCampoExpediente, setCampoCargando, setCampoError } =
    useContext(ExpedientesContext)

  const campos = campos_expediente
  const campo = campos.filter((c) => c.columna === columna)[0]
  const valor = campo.valor ? dayjs(campo.valor) : null

  useEffect(() => {
    if (campo && campo?.inicializar) {
      setCampoCargando(campo.columna, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (valor && campo.validacion === 'S') {
      setCampoCargando(campo.columna, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valor])

  const handleError = (message, columna) => {
    if (message) {
      setCampoError(columna, message)
    }
  }

  const handleChange = (newValue) => {
    try {
      setCampoExpediente(campo, dayjs(newValue).format('YYYY-MM-DD'))
      handleError('', campo.columna)
    } catch (error) {
      handleError(error.message, campo.columna)
    }
  }

  if (campo && campo.oculto !== 'S') {
    return (
      <LocalizationProvider
        localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
        dateAdapter={AdapterDayjs}
        adapterLocale="es"
      >
        <Box key={campo.columna} sx={{ width: campo.ancho ? campo.ancho + '%' : '100%' }}>
          <Box sx={{ display: 'flex' }}>
            <LabelComponent text={campo.literal} />
            {campo.error && (
              <LabelComponent
                text={'* ' + campo.error}
                sx={{
                  color: campo.error ? 'error.main' : 'inherit',
                  ml: 2,
                  fontSize: '0.8rem',
                  fontWeight: '400',
                }}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <CustomDateTimeComponent
              campo={campo}
              valor={valor}
              onChange={(v) => handleChange(v)}
            />
          </Box>
        </Box>
      </LocalizationProvider>
    )
  }
}

export default DateComponent
